import PageList from './PageList';
import PageListBlock from './PageListBlock';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelPageListCategory } = opts;
  PageListBlock(bm, labelPageListCategory, labels.pageList, types.pageList, opts);
  PageList(dc, labels.pageList, types.pageList, opts);
};
